// PINBALL (§13.4): A minor, 124.1 BPM, synthwave funk. Octave-popping slap-FM bass, gated saw
// chords, a pulse arp, a square lead and a 909-ish kit with open hats on the 'a' of 2 and 4.
// A: i–VI–VII–v twice (the second ending on the harmonic V7); B: the minor circle of fifths
// iv–VII–III–VI–iiø–V–i.
import type { SongDef } from '../songTypes';

export const PINBALL: SongDef = {
  id: 'pinball',
  rootMidi: 57,
  scale: 'minor',
  swing: 0.1,
  bars: 16,
  chords: [
    'i7', 'VImaj7', 'VII', 'v7', 'i7', 'VImaj7', 'VII', 'V7',
    'iv7', 'VII', 'IIImaj7', 'VImaj7', 'iiø7', 'V7', 'i7', 'V7',
  ],
  drums: { kick: 'X...x...X...x..o', snare: '....X.......X...', hat: 'xoxoxoxOxoxoxoxO', perc: '....x.......x...' },
  drumsB: { kick: 'X...x...X..ox...', snare: '....X.......X..o', hat: 'xoxoxoxOxoxoxoxO', perc: '....x.......x..x' },
  fill: { kick: 'x...x...x.x.x.x.', snare: '....x...xxxxXXXX', hat: 'x.x.x.x.........', perc: '................' },
  pickup: { kick: 'x...x...x...x...', snare: '........x.x.xxXX', hat: 'x.x.x.x.x.x.x.x.' },
  bass: [
    'A1! . A2 . . A1? . A2 G2 . E2 . A1 . G2 A2',
    'F1! . F2 . . F1? . F2 E2 . C2 . F1 . E2 F2',
    'G1! . G2 . . G1? . G2 D2 . F2 . G1 . D2 G2',
    'E1! . E2 . . E1? . E2 D2 . B1 . E1 . D2 E2',
    'A1! . A2 . . A1? . A2 G2 . E2 . A1 . C2 E2',
    'F1! . F2 . . F1? . F2 E2 . C2 . F1 . A1 C2',
    'G1! . G2 . . G1? . G2 D2 . F2 . G1 . B1 D2',
    'E1! . E2 . . E1? . E2 D2 . B1 . G#1 . B1 E2',
    'D2! . D3 . . D2? . D3 C3 . A2 . D2 . C3 D3',
    'G1! . G2 . . G1? . G2 D2 . F2 . G1 . F2 G2',
    'C2! . C3 . . C2? . C3 B2 . G2 . C2 . G2 B2',
    'F1! . F2 . . F1? . F2 E2 . C2 . F1 . C2 E2',
    'B1! . B2 . . B1? . B2 A2 . F2 . B1 . D2 F2',
    'E1! . E2 . . E1? . E2 D2 . B1 . G#1 . B1 D2',
    'A1! . A2 . . A1? . A2 G2 . E2 . A1 . C2 E2',
    'E1! . E2 . . E1? . E2 D2 . B1 . G#1 . E2 G#2',
  ],
  lead: [
    'E5 - - - . . A5 - - - G5 - E5 - - -',
    'C5 - - - . . E5 - - - F5 - A5 - - -',
    'G5 - - - . . D5 - - - B4 - D5 - - -',
    'E5 - - - - - - - D5 - B4 - G4 - - -',
    'E5 - - - . . A5 - - - B5 - C6 - - -',
    'A5 - - - - - G5 - - - F5 - E5 - - -',
    'D5 - - - . . G5 - - - E5 - D5 - - -',
    'E5 - - - - - D5 - - - B4 - G#4 - - -',
    'F5 - - - A5 - - - C6 - - - A5 - - -',
    'B5 - - - - - A5 - G5 - - - D5 - - -',
    'E5 - - - G5 - - - B5 - - - - - - -',
    'A5 - - - - - G5 - F5 - - - C5 - - -',
    'D5 - - - F5 - - - A5 - - - F5 - D5 -',
    'E5 - - - G#5 - - - B5 - - - D6 - - -',
    'C6 - - - - - B5 - A5 - - - E5 - - -',
    'G#5 - - - - - - - . . B5 - G#5 - E5 -',
  ],
  arp: '1 5 8 12 10 8 5 8 1 5 8 12 10 8 5 3',
  comp: 'X-x.x-x.X-x.x-x.',
  compB: 'X-x.x-x.X-x.xxX.',
  voicing: 'close',
  chordRange: [57, 76],
  instruments: { bass: 'slapBass', chords: 'sawChord', lead: 'squareLead', arp: 'pulseArp', perc: 'clap' },
  kit: { kick: 'kick909', snare: 'snare909', hat: 'hat909', hatOpen: 'hatOpen', crash: 'crash' },
  stabs: 'X.....x...x.....',
  mix: { hat: -4, perc: -6, chords: -3, arp: -6, bass: -2 },
};
